import { Action } from 'redux';
import { Epic, ofType } from 'redux-observable';
import { from, Observable, of } from 'rxjs';
import { catchError, mergeMap, switchMap } from 'rxjs/operators';

import { changeLocation } from '../../actions/common';
import {
    FETCH_MARKETERS_DATA,
    FILTER_MARKETERS,
    setMarketersPageStatus,
    updateMarketersData
} from '../../actions/marketers/marketersList';
import { selectMarketersSortParams } from '../../selectors/marketers';
import { EpicDeps } from '../../service/StoreFactory';
import { MarketersPageStates } from '../../typings/marketers';
import { State } from '../../typings/state';

export const fetchMarketersDataEpic: Epic<Action, Action, State, EpicDeps> = (
    action$,
    store$,
    deps
) => {
    return action$.pipe(
        ofType(FETCH_MARKETERS_DATA),
        mergeMap(
            (): Observable<Action> => {
                return from(
                    deps.marketersDataProvider.fetchMarketersData()
                ).pipe(
                    mergeMap(response => {
                        const sortParams = selectMarketersSortParams(
                            store$.value
                        );

                        return of(
                            updateMarketersData(response, sortParams),
                            setMarketersPageStatus(MarketersPageStates.LOADED)
                        );
                    }),
                    catchError(() =>
                        of(setMarketersPageStatus(MarketersPageStates.ERROR))
                    )
                );
            }
        )
    );
};

export const resetUrlAfterFilterResetEpic: Epic<
    Action,
    Action,
    State,
    EpicDeps
> = (action$, store$, deps) => {
    return action$.pipe(
        ofType(FILTER_MARKETERS),
        switchMap(() => {
            const state = store$.value;
            const { router } = state;
            return of(
                changeLocation(
                    router.pathname,
                    {
                        ulogin: (router.query && router.query.ulogin) || ''
                    },
                    false
                )
            );
        })
    );
};
